import { useState, useEffect } from "react";

type LazyImageProps = {
  src: string;
  alt: string;
  className?: string;
  loadingClassName?: string;
};

export default function LazyImage({ src, alt, className = "", loadingClassName = "" }: LazyImageProps) {
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    const img = new Image();

    function handleLoad() {
      setImageLoading(false);
    }

    function handleError() {
      console.error("Error loading image");
      setImageLoading(false);
    }

    img.addEventListener("load", handleLoad);
    img.addEventListener("error", handleError);

    img.src = src;

    if (img.complete) {
      setImageLoading(false);
    }

    return () => {
      img.removeEventListener("load", handleLoad);
      img.removeEventListener("error", handleError);
    };
  }, [src]);

  return (
    <>
      {imageLoading && <div className={`absolute inset-0 bg-gray-200/80 animate-pulse ${loadingClassName}`} />}
      <img
        className={`${imageLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-300 ${className}`}
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
      />
    </>
  );
}
